<!-- loaderTemplate -->
@let loaderTemplate = getTemplate('loaderTemplate')?.templateRef;

<div
  class="tree_container p-1"
  [class.tree_loading]="loading()"
  [class.tree_loading_mode_mask]="loadingIsMask()"
  [skipSelfPositionValue]="skipSelfLoadingContainer()"
  [appBlockUi]="loading() && loaderTemplate == null">

  <!-- start loading -->
  @if (loading()) {
    <div class="tree_wrapper_loader">
      
      @if (loaderTemplate; as temp) {
        <ng-container *ngTemplateOutlet="temp; context: { $implicit: loadingIcon() }" />
      }
      @else {
        
        <!-- start loadingIconTemplate -->
        @let loadingIconTemplate = getTemplate('loadingIconTemplate')?.templateRef;

        <div #blockElement>
          <div class="tree_loading_icon">
            <ng-container *ngTemplateOutlet="loadingIconTemplate ?? defaultLoader; context: { $implicit: loadingIcon() }" />
          </div>
        </div>

      }

    </div>
  }

  <!-- start headerTemplate -->
  @let headerTemplate = getTemplate('headerTemplate')?.templateRef;

  @if (headerTemplate; as temp) {
    <ng-container *ngTemplateOutlet="temp" />
  }

  <!-- start filter -->
  @if (filter()) {
    <div class="tree_filter mb-1">
      <div class="filter_container">
        <div class="filter_input">
          <div class="wrap_search_box">
            
            @let filterTemplate = getTemplate('filterTemplate')?.templateRef;

            @if (filterTemplate; as temp) {
              
              @let context = {
                loading: loading(),
                filterLoading: filterLoading(),
                $implicit: treeState.filterFormControl,
              };

              <ng-container *ngTemplateOutlet="temp; context: context" />

            }
            @else {
              <app-field-group class="input_group_search" [class.loading]="filterLoading()" [merge]="true">
                
                <!-- start input field -->
                <input 
                  type="text"
                  id="tree_search_input"
                  name="tree_search_input"
                  appFormInputField 
                  [readonly]="filterLoading() || loading()"
                  [placeholder]="filterPlaceholder()"
                  (onChange)="handleFilter($event)"
                  [formControl]="treeState.filterFormControl"
                />

                <!-- start filterIcon -->
                <span class="bg-transparent" appElementTemplate="groupText">

                  <!-- start filterIconTemplate -->
                  @let filterIconTemplate = getTemplate('filterIconTemplate')?.templateRef;

                  @if (filterIconTemplate; as temp) {
                    <ng-container *ngTemplateOutlet="temp; context: { $implicit: filterLoading() }" />
                  }
                  @else {
                    <i
                      class="fa-regular"
                      [class.fa-spin]="filterLoading()"
                      [class.fa-search]="!filterLoading()"
                      [class.fa-spinner]="filterLoading()"
                    >
                    </i> 
                  }

                </span>
              </app-field-group>
            }
          </div>
        </div>
      </div>
    </div>
  }

  <!-- start empty state -->
  @if (!loading() && (!filteredNodes() || filteredNodes().length === 0)) {
    
    <!-- start emptyTemplate -->
    @let emptyTemplate = getTemplate('emptyTemplate')?.templateRef;

    <div class="tree_empty_state">
      <ng-container *ngTemplateOutlet="emptyTemplate; context: { $implicit: emptyMessage() }" />
    </div>

  }

  @if (filteredNodes() && filteredNodes().length > 0) {
    <div 
      class="tree_root"
      [style.max-height]="scrollHeight()" 
      [style.overflow-y]="scrollHeight() ? 'auto' : 'visible'"
      (scroll)="handleScroll($event)">
      <ul 
        appListGroup
        [flush]="true"
        class="tree_node_children"
        role="tree"
        [attr.aria-label]="ariaLabel() || 'Tree Component'"
      >
        @for (node of filteredNodes(); track trackBy() ? trackBy()($index, node) : node.key; let i = $index) {
          <app-tree-node [node]="node" />
        }
      </ul>
    </div>
  }

  <!-- start footerTemplate -->
  @let footerTemplate = getTemplate('footerTemplate')?.templateRef;

  @if (footerTemplate; as temp) {
    <ng-container *ngTemplateOutlet="temp" />
  }

</div>

<!-- 
  ====
  start defaultLoader
  ===
 -->
<ng-template #defaultLoader let-loadingIcon>
  @if (!loadingIsMask() && loadingIcon) {
    <i [class]="loadingIcon"></i>
  }
</ng-template>